import React from 'react';
import RealTrendsDashboard from '../../components/analytics/RealTrendsDashboard';

const RealAnalytics = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <RealTrendsDashboard />
      </div>
    </div>
  );
};

export default RealAnalytics;
